// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2mVDP","cardContent":"styles_cardContent__1YzwU","dumbellImg":"styles_dumbellImg__3ahTV","text":"styles_text__ki_VH"};